/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing tooltip directives and components.
 * @preferred
 * @module TooltipModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { VIPModule } from '@vmw/ngx-vip';
import { AviTooltipModule } from 'nsx-alb-ui-components';

import {
    AviHoverOverlayComponent,
    AviLabelWithTooltipComponent,
    AviTooltipContentComponent,
    AviTooltipIconComponent,
    AviTooltipIconWithContentWrapperComponent,
    AviTooltipTextComponent,
    HelperTextTooltipIconComponent,
    SignpostComponent,
} from './components';

import {
    AviTitleDirective,
} from './directives';

const components = [
    AviHoverOverlayComponent,
    AviLabelWithTooltipComponent,
    AviTooltipContentComponent,
    AviTooltipIconComponent,
    AviTooltipIconWithContentWrapperComponent,
    AviTooltipTextComponent,
    HelperTextTooltipIconComponent,
    SignpostComponent,
];

const directives = [
    AviTitleDirective,
];

@NgModule({
    declarations: [
        ...components,
        ...directives,
    ],
    exports: [
        AviHoverOverlayComponent,
        AviLabelWithTooltipComponent,
        AviTitleDirective,
        AviTooltipContentComponent,
        AviTooltipIconComponent,
        AviTooltipIconWithContentWrapperComponent,
        HelperTextTooltipIconComponent,
        SignpostComponent,
    ],
    imports: [
        AviTooltipModule,
        CommonModule,
        FormsModule,
        OverlayModule,
        VIPModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class TooltipModule {}
